import React from 'react'
import type { DrawerProps } from '@/ui/components'
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerTitle,
} from '@/ui/components'
import { graphql } from 'babel-plugin-relay/macro'
import { useFragment } from 'react-relay-offline'
import { useIntl } from 'react-intl'

import type { ProductDetailsDrawer_Product$key } from './__generated__/ProductDetailsDrawer_Product.graphql'

export const productFragment = graphql`
  fragment ProductDetailsDrawer_Product on Product {
    description
  }
`

type ProductDetailsDrawerProps = DrawerProps & {
  productDescription: ProductDetailsDrawer_Product$key | null
}

export const ProductDetailsDrawer = ({
  productDescription,
  ...props
}: ProductDetailsDrawerProps) => {
  const data = useFragment(productFragment, productDescription)
  const { formatMessage } = useIntl()

  if (!data?.description) {
    return null
  }

  return (
    <Drawer {...props} data-testid="product-details-drawer">
      <DrawerTitle>
        {formatMessage({ id: 'productDetailsDrawerTitle' })}
      </DrawerTitle>
      <DrawerCloseButton />
      <DrawerBody dangerouslySetInnerHTML={{ __html: data?.description }} />
    </Drawer>
  )
}
